import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../../orpc'

export function useRosterCreate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.roster.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.roster.key() })
        queryClient.invalidateQueries({ queryKey: orpc.trip.key() })
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

export function useRosterUpdate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.roster.update.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.roster.key() })
        queryClient.invalidateQueries({ queryKey: orpc.trip.key() })
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

export function useRosterDelete() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.roster.delete.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.roster.key() })
        queryClient.invalidateQueries({ queryKey: orpc.trip.key() })
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

export function useRosterDeleteByRange() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.roster.deleteByRange.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.roster.key() })
        queryClient.invalidateQueries({ queryKey: orpc.trip.key() })
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

export function useRosterDeleteHistory() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.roster.deleteHistory.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.roster.key() })
        queryClient.invalidateQueries({ queryKey: orpc.trip.key() })
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}
